import { apiRequest } from '@/utils/apiRequest'
import { apiUrl } from '@/utils/apiUrl'
import { withCurrentStaff } from '@/utils/withCurrentStaff'

class CartSessionRepository {
	constructor() {
		const host = window.location.hostname
		if (host === 'localhost' || host.startsWith('192.168')) {
			this.urlBase = process.env.VUE_APP_API_BASE_URL
		} else {
			this.urlBase = window.location.origin
		}
	}

	async processOrder(cartSessionOrderId, roleId) {
		try {
			const response = await apiRequest({
				url: apiUrl('/world/api/cartsession/processorder'),
				method: 'POST',
				body: withCurrentStaff({ cartSessionOrderId, roleId }),
				throwOnNonOk: false,
			})
			if (!response.ok) return response.status
			return response.data
		} catch (e) {
			console.log('Ups, algo ha ido mal obteniendo procesando el pedido.')
		}
	}

	async createCartSessionOrder(orderInfo, products) {
		console.log('Creando cartSession order')
		try {
			const response = await apiRequest({ url: apiUrl('/world/api/cartsession/createcartsessionorder'), method: 'POST', body: { orderInfo, products }, throwOnNonOk: false })
			if (!response.ok) return response.status
			return response.data
		} catch (e) {
			console.log('Ups, algo ha ido mal obteniendo procesando el pedido.')
		}
	}
}

export const cartSessionRepository = new CartSessionRepository()
